<template>
  <span :class="statusClass">
    {{ statusText }}
  </span>
</template>

<script>
export default {
  name: 'reservation-status',
  props: {
    status: {
      type: Number,
      required: true
    },
    present: {
      default: null,
      required: false
    }
  },
  computed: {
    statusText () {
      if (this.present === 0) {
        return this.$t('reservationStatus.clientNotPresent');
      }

      switch (this.status) {
        case 1: return this.$t('reservationStatus.newRequest');
        case 3: return this.$t('reservationStatus.confirmed');
        case 4: return this.$t('reservationStatus.rejected');
        case 6: return this.$t('reservationStatus.waitingList');
        default: return this.$t('reservationStatus.cancelled');
      }
    },
    statusClass () {
      if (this.present === 0) {
        return 'is-rejected';
      }

      switch (this.status) {
        case 1: return 'is-waiting';
        case 3: return 'is-confirmed';
        case 4: return 'is-rejected';
        case 6: return 'is-waiting-list';
        default: return 'is-cancelled';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

span {
  border: 1px solid $color-primary;
  border-radius: $border-radius-small;
  color: $color-primary;
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 600;
  margin: .5rem 0;
  padding: .125rem .5rem;
  text-align: center;
  text-transform: uppercase;

  &.is-waiting {
    border-color: $color-notice;
    color: $color-notice;
  }

  &.is-confirmed {
    border-color: $color-success;
    color: $color-success;
  }

  &.is-rejected {
    border-color: $color-danger;
    color: $color-danger;
  }

  &.is-cancelled {
    border-color: $color-text-light;
    color: $color-text-light;
  }

  &.is-waiting-list {
    border-color: $color-warning;
    color: $color-warning;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ReservationStatus.vue